"use client";
import "../../../chunk-MMUBH76A.js";
const getActions = (set) => ({
  updateState: (state) => {
    set(state);
  }
});
export {
  getActions
};
